import { apiConnector } from "../apiConnector"
import { apiClient } from "../apiClient"
import { setAttendance } from "../../slices/Attendance"
import { toast } from "react-hot-toast"

/* ============ Manager Bussiness Logic ================= */
export function Get_Attendance(EmpId='All',from,to){
    const token = localStorage.getItem("token")
    return async(dispatch)=>{
        try {
            const response = await apiConnector("GET",apiClient.GET_ATTENDANCE + `/${EmpId}/${from}/${to}`,null,{
                Authorization:`Bearer ${token}`
            })
            if(!response.data.success){
                throw new Error(response.data.message)
            }
            dispatch(setAttendance(response.data.data))
            toast.success(response.data.message)
        } catch (error) {
            console.log("Error In Get_Attendance Function:",error.message)
            toast.error(error.message)
        }
    }
}

/* ============ Organization Bussiness Logic ============= */
export function Get_Attendance_Org(EmpId='All',from,to){
    const token = localStorage.getItem("token")
    console.log("Call GetAttendance_Org:",from,to)
    return async(dispatch)=>{
        try {
            const response = await apiConnector("GET",apiClient.GET_ATTENDANCE_ORG + `/${EmpId}/${from}/${to}`,null,{
                Authorization:`Bearer ${token}`
            })
            console.log("Get_Attendance_Org Response:",response)
            if(!response.data.success){
                throw new Error(response.data.message)
            }
            dispatch(setAttendance(response.data.data))
            toast.success(response.data.message)
        } catch (error) {
            const message = error.response?.data?.message||error.message
            console.log("Error In Get_Attendance Function:",message)
            toast.error(message)
        }
    }
}
